// Tiny markdown-ish renderer (bold, italic, code, headings, lists). Safe & dependency-free.
import React from "react";

function escapeHtml(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function inline(s) {
  s = escapeHtml(s);
  // code
  s = s.replace(/`([^`]+)`/g, "<code>$1</code>");
  // bold
  s = s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  // italic
  s = s.replace(/(^|\s)\*([^*]+)\*/g, "$1<em>$2</em>");
  // links [text](url)
  s = s.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');
  return s;
}

export default function Markdown({ text = "" }) {
  if (!text) return null;
  const lines = text.split("\n");
  const out = [];
  let inCode = false;
  let codeBuf = [];
  let listBuf = [];
  let listType = null;

  const flushList = () => {
    if (listBuf.length) {
      const Tag = listType === "ol" ? "ol" : "ul";
      out.push(
        <Tag key={`l${out.length}`}>
          {listBuf.map((li, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: inline(li) }} />
          ))}
        </Tag>
      );
      listBuf = [];
      listType = null;
    }
  };

  lines.forEach((line, i) => {
    if (line.trim().startsWith("```")) {
      if (inCode) {
        out.push(
          <pre key={`c${i}`}>
            <code>{codeBuf.join("\n")}</code>
          </pre>
        );
        codeBuf = [];
        inCode = false;
      } else {
        flushList();
        inCode = true;
      }
      return;
    }
    if (inCode) {
      codeBuf.push(line);
      return;
    }
    const h = line.match(/^(#{1,3})\s+(.*)$/);
    if (h) {
      flushList();
      const level = h[1].length;
      const Tag = `h${level}`;
      out.push(<Tag key={`h${i}`} dangerouslySetInnerHTML={{ __html: inline(h[2]) }} />);
      return;
    }
    const ul = line.match(/^\s*[-*]\s+(.*)$/);
    const ol = line.match(/^\s*\d+\.\s+(.*)$/);
    if (ul) {
      if (listType && listType !== "ul") flushList();
      listType = "ul";
      listBuf.push(ul[1]);
      return;
    }
    if (ol) {
      if (listType && listType !== "ol") flushList();
      listType = "ol";
      listBuf.push(ol[1]);
      return;
    }
    flushList();
    if (line.trim() === "") {
      out.push(<br key={`br${i}`} />);
    } else {
      out.push(
        <p key={`p${i}`} dangerouslySetInnerHTML={{ __html: inline(line) }} />
      );
    }
  });
  flushList();
  if (inCode && codeBuf.length) {
    out.push(
      <pre key="cend">
        <code>{codeBuf.join("\n")}</code>
      </pre>
    );
  }
  return <div className="md">{out}</div>;
}
